import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { ReportTypes } from "../../../../../Constants";
import { ReportButton } from "../../../../../Components/Buttons/ReportButton/ReportButton";
import "./ReportModal.scss";

export function ReportModal({ reportBook, book, ...props }) {
  const [t] = useTranslation();
  const [report, setReport] = useState(book.reportType);

  const updateBookReport = async () => {
    reportBook({ ...book, state: 2, reportType: report });
    props.onHide();
  };

  return (
    <Modal {...props} dialogClassName="report-modal">
      <Modal.Header closeButton />
      <Modal.Body className="report-modal-content">
        <span className="title">{t("HomePageCardReportLink")}</span>
        <span className="sub-title">{t("ReportModalTitle")}</span>
        <div className="reportModal-content-options invisibleScroll">
          {ReportTypes.map((x) => (
            <ReportButton
              key={x.id}
              active={x.id === report}
              reportKey={x.id}
              reportText={t(x.name)}
              reportDescription={t(x.description)}
              onClick={() => {
                setReport(x.id);
              }}
            />
          ))}
        </div>
        <div className="button-wrapper">
          <Button
            disabled={report === 0}
            className="button"
            onClick={updateBookReport}
          >
            {t("ReportModalReportBtn")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
